module.exports = __webpack_public_path__ + "img/統計学入門_2_3_問題.97e87d46.png";